<template>

  <div>
    <div class="card mb-0">
      <div class="card-body">
        <h2>{{ candidate.name }}</h2>
        <h4>{{ candidate.subareas_or_technologies.join(', ') }}.</h4>
        <p class="m-0">{{ candidate.work_location.join(', ') }}.</p>
    
        <div
          class="alert my-4"
          :class="status === 'accessible' ? 'alert-secondary' : 'alert-primary'"
          :style="{ background: status === 'accessible' ? 'transparent' : '' }">
          <div v-if="status === 'accessible'">
            <table>
              <tr>
                <td class="p-1"><b>Telefone:</b></td>
                <td>
                  <span class="mr-2">{{ candidate.phone }}</span>
                  <a href="#"><i class="fa fa-whatsapp" /></a>
                  <a href="#"><i class="fas fa-phone-alt" /></a>
                  <a href="#"><i class="fa fa-copy" /></a>
                </td>
              </tr>
              <tr>
                <td class="p-1"><b>E-mail:</b></td>
                <td><a href="#">{{ candidate.email }}</a></td>
              </tr>
            </table>
          </div>
          <div v-if="status === 'applied'">
            <p>Este candidato está de olho na vaga.</p>
            <button
              type="button"
              class="btn btn-primary"
              @click="changeStatus('contact', candidate.candidate_id)">Exibir contatos</button>
          </div>
          <div v-if="status === 'matched'">
            <p>Interessado em conhecer esse talento?</p>
            <button
              type="button"
              class="btn btn-primary"
                @click="changeStatus('invited', candidate.candidate_id)">Abordar</button>
          </div>
          <div v-if="status === 'invited'">
            Convite enviado! Aguardando resposta do candidato.
          </div>
        </div>
    
        <div class="mt-3"><b>Skills:</b></div>
        <div class="skills">
          <span
            v-for="(skill) in Object.entries(candidate.skills)"
            class="alert"
            :class="{'alert-success': skill[1] === 3, 'alert-primary': skill[1] === 2, 'alert-secondary': skill[1] === 1}">{{ skill[0] }}</span>
        </div>

        <div class="mt-3"><b>Idiomas:</b></div>
        <div class="skills">
          <span
            v-for="(option, o) in candidate.languages"
            :key="o"
            class="alert alert-secondary">
            {{ option }}
          </span>
        </div>

        <div class="mt-3"><b>Valores Importantes:</b></div>
        <div class="skills">
          <span
            v-for="(option, o) in candidate.important_values"
            :key="o"
            class="alert alert-secondary">
            {{ option }}
          </span>
        </div>

        <div class="mt-3"><b>Áreas Desejadas:</b></div>
        <div class="skills">
          <span
            v-for="(option, o) in candidate.desired_areas"
            :key="o"
            class="alert alert-secondary">
            {{ option }}
          </span>
        </div>

        <div class="mt-3"><b>Preferências de Trabalho:</b></div>
        <div class="skills">
          <span
            v-for="(option, o) in candidate.work_preferences"
            :key="o"
            class="alert alert-secondary">
            {{ option }}
          </span>
        </div>

        <div class="mt-3"><b>Tipo de Empresa Preferida:</b></div>
        <div class="skills">
          <span
            v-for="(option, o) in candidate.preferred_company_type"
            :key="o"
            class="alert alert-secondary">
            {{ option }}
          </span>
        </div>

        <div class="mt-3"><b>Setores Preferidos:</b></div>
        <div class="skills">
          <span
            v-for="(option, o) in candidate.preferred_sectors"
            :key="o"
            class="alert alert-secondary">
            {{ option }}
          </span>
        </div>

        <div class="mt-3"><b>Setores Indesejados:</b></div>
        <div class="skills">
          <span
            v-for="(option, o) in candidate.unwanted_sectors"
            :key="o"
            class="alert alert-secondary">
            {{ option }}
          </span>
        </div>

        <div class="mt-3"><b>Tipo de Contrato:</b></div>
        <div class="skills">
          <span
            v-for="(option, o) in candidate.contract_type"
            :key="o"
            class="alert alert-secondary">
            {{ option }}
          </span>
        </div>

        <div class="mt-3"><b>Principais Benefícios:</b></div>
        <div class="skills">
          <span
            v-for="(option, o) in candidate.main_benefits"
            :key="o"
            class="alert alert-secondary">
            {{ option }}
          </span>
        </div>

        <div class="mt-3"><b>Condições Inaceitáveis:</b></div>
        <div class="skills">
          <span
            v-for="(option, o) in candidate.unacceptable_conditions"
            :key="o"
            class="alert alert-secondary">
            {{ option }}
          </span>
        </div>

        <div class="mt-3"><b>Valores Pessoais:</b></div>
        <div class="skills">
          <span
            v-for="(option, o) in candidate.personal_values"
            :key="o"
            class="alert alert-secondary">
            {{ option }}
          </span>
        </div>

        <div class="mt-3"><b>Estilo Comportamental:</b></div>
        <div class="skills">
          <span
            v-for="(option, o) in candidate.behavioral_style"
            :key="o"
            class="alert alert-secondary">
            {{ option }}
          </span>
        </div>

        <iframe
          class="mt-3"
          v-resize="{ log: false }"
          src="https://quickin-pdfviewer.s3-sa-east-1.amazonaws.com/generic/web/viewer.html?file=https%3A%2F%2Fdoconvert.quickin.io%2Fpdf-convert%3Furl%3Dhttps%3A%2F%2Fquickin-media-production.s3.sa-east-1.amazonaws.com%2FpFCGCjvRJUOVWc5OmodFLNDlSjWP6KHCJ5uhv0eHiK1JgNK9Le0tMCEPCyWRI9sx%2FCVatualizado.pdf"
          style="border: 0; width: 100%; min-height: 300px; height: 2000px;" />

      </div>
    </div>
  </div>

</template>

<script>
import ThSort from '@/components/Parts/ThSort'
import RhevolutJobConfig from './RhevolutJobConfig'
import RhevolutJobForm from './RhevolutJobForm'
import RhevolutJobItem from './RhevolutJobItem'
import Paginaty from '@/components/Paginaty/Paginaty'

export default {
  name: 'RhevolutJob',
  components: {
    ThSort,
    RhevolutJobConfig,
    RhevolutJobForm,
    RhevolutJobItem,
    Paginaty
  },
  props: {
    candidate: {
      type: Object
    },
    tab: {
      type: String
    }
  },
  data () {
    return {
    }
  },
  computed: {
    status () {
      if (this.candidate.accessible) {
        return 'accessible'
      } else {
        if (this.candidate.applied) {
          return 'applied'
        } if (this.candidate.invited) {
          return 'invited'
        } else {
          return 'matched'
        }
      }
    }
  },
  watch: {
  },
  created () {
  },
  methods: {
    changeStatus (status, id) {
      this.$emit('changeStatus', { status, id })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.skills {
  display: flex;
  flex-wrap: wrap;
}
.skills > * {
  margin: 0.1em;
  padding: 0.3em 0.8em;
  border-radius: 2em;
}

.profile {
  background: rgba(0,0,0,0.1);
}

.options {
  display: flex;
  flex-wrap: wrap;
}
  .options * {
    padding: 0.4em 0.8em;
    margin: 0.2em;
  }
.btn-options {
  padding: 0.5em;
  display: flex;
}
  .btn-options > span {
    display: block;
    padding: 0.4em;
    flex: 1;
    text-align: left;
  }
  .btn-options > select {
    display: block;
    flex: 1;
  }
.btn-option-binary {
  display: flex;
}
  .btn-option-binary > * {
    flex: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/RhevolutJob/RhevolutJobProfile.vue